import {Pipe, PipeTransform} from "@angular/core";
import {EventDate} from "../../model";

@Pipe({
  name: 'sortDates',
  standalone: true
})
export class SortDatesPipe implements PipeTransform {

  transform(value: EventDate[] | undefined | null, order: 'asc' | 'desc' = 'asc'): EventDate[] {
    console.log(value);
    if (!value) {
      return [];
    }

    const sortedArray = [...value];
    sortedArray.sort((a, b) => {
      const dateA = a.date!.getTime();
      const dateB = b.date!.getTime();
      return order === 'asc' ? dateA - dateB : dateB - dateA;
    });

    return sortedArray;
  }
}
